import React from 'react';

const Logo: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/image.png"
        alt="Wizlytics Logo"
        className="h-12 w-auto flex-shrink-0"
      />
    </div>
  );
};

export default Logo;

